import React from 'react';

export type DiaProps = {
    /** Número del día donde 1 = lunes y 7 = domingo */
    readonly dia: number;
};

const DIAS = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

export const Dia = ({ dia }: DiaProps) => {
    return <>{DIAS[dia] || '???'}</>;
};



// WEBPACK FOOTER //
// ./src/componentes/Dia/index.tsx